import { formatDate } from '@angular/common';
import {
  DataTableRowActions,
  DataTableColumnBadgeProps,
  DataTableColumnTextProps,
  DataTableColumnVariant,
  DataTableVariant,
  DynamicDataTableColumn,
  DynamicDataTable,
} from '@/components/data-table-builder/data-table.types';
import { DataTableServerQuery } from '@/components/data-table-builder/data-table.types';
import { TranslateService } from '@ngx-translate/core';
import { ReportAdditifResponseDto } from '@/types';

interface GetReportRequestDataTableStructureProps {
  translate: (key: string) => string;
  rowActionsFn?: (row: ReportAdditifResponseDto) => DataTableRowActions;
  serverQuery?: DataTableServerQuery;
}

export const getReportRequestDataTableStructure = ({ translate, rowActionsFn, serverQuery }: GetReportRequestDataTableStructureProps): DynamicDataTable => {
  const dacReferenceColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.table.dac_reference',
    accessorKey: 'dacReference',
    variant: DataTableColumnVariant.TEXT,
  };

  const dateReportColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.form.date',
    accessorKey: 'dateReport',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? formatDate(value, 'dd/MM/yyyy HH:mm', 'en-US', 'UTC') : '-',
      };
    },
  };

  const statusColumn: DynamicDataTableColumn<DataTableColumnBadgeProps> = {
    label: 'clarification.table.status',
    accessorKey: 'status',
    variant: DataTableColumnVariant.BADGE,
    renderAs(value) {
      return { value: `clarification.status.${value}` };
    },
    props: {
      getSeverity: (value: string) => {
        if (value === 'BROUILLON') return 'success';
        if (value === 'EN_TRAITEMENT') return 'contrast';
        if (value === 'VALIDE') return 'success';
        if (value === 'REJETE') return 'danger';
        return 'info';
      },
    },
  };

  const etapeProcessolumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.reports.form.etape_process',
    accessorKey: 'etapeProcess',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value,
      };
    },
  };

  const createdColumn: DynamicDataTableColumn<DataTableColumnTextProps> = {
    label: 'clarification.table.created',
    accessorKey: 'createdAt',
    variant: DataTableColumnVariant.TEXT,
    renderAs: (value: string) => {
      return {
        value: value ? formatDate(value, 'dd/MM/yyyy HH:mm', 'en-US') : '-',
      };
    },
  };

  return {
    singular: 'clarification.report_request.singular',
    plural: 'clarification.report_request.plural',
    columns: [dacReferenceColumn, dateReportColumn, statusColumn, etapeProcessolumn, createdColumn],
    variant: DataTableVariant.COMMON,
    sizes: [10, 20, 50],
    stripedRows: true,
    enableServerActions: true,
    searchableFields: ['dacReference', 'motifReport'],
    rowActionsFn,
    serverQuery,
  };
};
